<!-- 項目外框 -->
<template>
  <div class="box">
    <base-title v-if="title"><span style="flex:1">{{title}}</span><slot name="sub-com"></slot></base-title>
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'base-container',
  props: {
    title: String,
    hasTitle: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="stylus" scoped>

.box
  text-align left
  padding 30px
  .title
    padding: 20px 0 30px;
    display flex
hr
  margin 20px 0
</style>
